<template>
    <Webinar></Webinar>
</template>
<script>
    import Webinar from "@/components/Webinar.vue";
    export default {
        components: {
            Webinar
        },
    }
</script>